const StatusDisplay = (p5, currentState, signalLockStrength, width, height, entanglement_coefficient, quantum_coherence, quantum_phase, margins, frequency, snr, qFactor, bandwidth, harvestedQubits) => {
  p5.textFont('IBM BIOS');
  p5.textSize(12);
  p5.textAlign(p5.CENTER, p5.BOTTOM);
  
  let status = "";
  
  switch(currentState) {
    case 'SCANNING':
      status = "SCANNING QUANTUM FIELD";
      // More dramatic pulsing effect
      const pulseIntensity = 0.3 + 0.7 * Math.sin(p5.frameCount * 0.1);
      p5.fill(0, 255 * pulseIntensity, 0, 255 * pulseIntensity);
      p5.text(status, width/2, height - 45);
      
      // Add scanning dots animation
      let dots = "";
      const numDots = Math.floor(p5.frameCount / 20) % 4;
      for (let i = 0; i < numDots; i++) dots += ".";
      p5.text(dots, width/2 + p5.textWidth(status)/2 + 20, height - 45);
      
      // Display quantum metrics
      displayQuantumMetrics(p5, width, height, entanglement_coefficient, quantum_coherence, quantum_phase, margins, frequency, snr, qFactor, bandwidth, harvestedQubits);
      break;
      
    case 'SIGNAL_FOUND':
      status = `SIGNAL DETECTED - LOCKING ${Math.floor(signalLockStrength * 100)}%`;
      p5.fill(0, 255, 0, 200);
      p5.text(status, width/2, height - 45);
      displayQuantumMetrics(p5, width, height, entanglement_coefficient, quantum_coherence, quantum_phase, margins, frequency, snr, qFactor, bandwidth, harvestedQubits);
      break;
      
    case 'DISPLAYING_CALL':
      status = "SIGNAL LOCKED - DECODING PACKETS";
      p5.fill(0, 255, 0, 200);
      p5.text(status, width/2, height - 45);
      displayQuantumMetrics(p5, width, height, entanglement_coefficient, quantum_coherence, quantum_phase, margins, frequency, snr, qFactor, bandwidth, harvestedQubits);
      break;
      
    case 'SHOWING_LORE':
      status = "ANALYZING SIGNAL";
      p5.fill(0, 255, 0, 200);
      p5.text(status, width/2, height - 45);
      break;
  }
};

const drawMetric = (p5, x, y, label, value) => {
  p5.noStroke();
  p5.textFont('IBM BIOS');
  p5.textSize(10);
  
  // Determine if this is a left or right chunk metric based on x position
  const isLeftChunk = x < p5.width/2;
  
  // Set text alignment based on chunk position
  if (isLeftChunk) {
    p5.textAlign(p5.RIGHT, p5.CENTER);
  } else {
    p5.textAlign(p5.LEFT, p5.CENTER);
  }
  
  // Draw label and value
  const fullText = `${label}: ${value}`;
  p5.fill(0, 255, 0, 150);
  p5.text(fullText, x, y);
};

const displayQuantumMetrics = (p5, width, height, entanglement_coefficient, quantum_coherence, quantum_phase, margins, frequency, snr, qFactor, bandwidth, harvestedQubits) => {
  // Format values
  const entanglement = (entanglement_coefficient * 100).toFixed(1);
  const coherence = quantum_coherence.toFixed(1);
  const phase = (quantum_phase / p5.TWO_PI * 360).toFixed(1);
  const freqFormatted = `${frequency.toFixed(2)} MHz`;
  const snrFormatted = `${snr.toFixed(1)} dB`;
  const qFactorFormatted = `${qFactor.toFixed(1)}`;
  const bandwidthFormatted = `${bandwidth.toFixed(1)} kHz`;

  // Calculate positions for left and right chunks
  const sineWidth = width * 0.7; // Match sine wave width
  const sineX = (width - sineWidth) / 2;
  const rowSpacing = 12;

  // Position metrics just above the sine wave, with padding to match sine wave edges
  const padding = sineWidth * 0.1; // 10% padding on each side to match sine wave
  const leftX = sineX + padding;
  const rightX = sineX + sineWidth - padding;
  const baseY = height - 10; // Move up from sine wave top edge
  const row1Y = baseY;
  const row2Y = baseY - rowSpacing;
  const row3Y = baseY - (rowSpacing * 2);

  // Draw left chunk metrics
  drawMetric(p5, leftX, row3Y, "FREQ", freqFormatted);
  drawMetric(p5, leftX, row2Y, "Q-FACTOR", qFactorFormatted);
  drawMetric(p5, leftX, row1Y, "ENTANGLEMENT", `${entanglement}%`);

  // Draw right chunk metrics
  drawMetric(p5, rightX, row3Y, "SNR", snrFormatted);
  drawMetric(p5, rightX, row2Y, "BANDWIDTH", bandwidthFormatted);
  drawMetric(p5, rightX, row1Y, "COHERENCE", `${coherence}%`);

  // Draw harvested qubits count in center between metrics
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.textSize(12);
  p5.fill(0, 255, 0, 200);
  const qubitCountY = row2Y + (rowSpacing / 2); // Position between row2Y and row3Y
  p5.text(`HARVESTED QUBITS: ${harvestedQubits || 0}`, width/2, qubitCountY);
};

export default StatusDisplay;